export default __webpack_public_path__ + "static/media/commitment-friendly.1c2d775f.png";